var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/trash"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/trash_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7666 4.64843C13.7541 4.64843 13.7354 4.64843 13.7166 4.64843C10.4104 4.31718 7.11039 4.19218 3.84164 4.52343L2.56664 4.64843C2.30414 4.67343 2.07289 4.48593 2.04789 4.22343C2.02289 3.96093 2.21039 3.73593 2.46664 3.71093L3.74164 3.58593C7.06664 3.24843 10.4354 3.37968 13.8104 3.71093C14.0666 3.73593 14.2541 3.96718 14.2291 4.22343C14.2104 4.46718 14.0041 4.64843 13.7666 4.64843Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.95408 4.01714C5.92908 4.01714 5.90408 4.01714 5.87283 4.01089C5.62283 3.96714 5.44783 3.72339 5.49158 3.47339L5.62908 2.65464C5.72908 2.05464 5.86658 1.22339 7.32283 1.22339H8.96033C10.4228 1.22339 10.5603 2.08589 10.6541 2.66089L10.7916 3.47339C10.8353 3.72964 10.6603 3.97339 10.4103 4.01089C10.1541 4.05464 9.91033 3.87964 9.87283 3.62964L9.73533 2.81714C9.64783 2.27339 9.62908 2.16714 8.96658 2.16714H7.32908C6.66658 2.16714 6.65408 2.25464 6.56033 2.81089L6.41658 3.62339C6.37908 3.85464 6.17908 4.01714 5.95408 4.01714Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.1479 14.6609H6.13535C3.9541 14.6609 3.8666 13.4546 3.79785 12.4796L3.3916 6.18587C3.37285 5.92962 3.57285 5.70462 3.8291 5.68587C4.0916 5.67337 4.31035 5.86712 4.3291 6.12337L4.73535 12.4171C4.8041 13.3671 4.8291 13.7234 6.13535 13.7234H10.1479C11.4604 13.7234 11.4854 13.3671 11.5479 12.4171L11.9541 6.12337C11.9729 5.86712 12.1979 5.67337 12.4541 5.68587C12.7104 5.70462 12.9104 5.92337 12.8916 6.18587L12.4854 12.4796C12.4166 13.4546 12.3291 14.6609 10.1479 14.6609Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.17915 11.2234H7.0979C6.84165 11.2234 6.62915 11.0109 6.62915 10.7546C6.62915 10.4984 6.84165 10.2859 7.0979 10.2859H9.17915C9.4354 10.2859 9.6479 10.4984 9.6479 10.7546C9.6479 11.0109 9.4354 11.2234 9.17915 11.2234Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.7041 8.72339H6.5791C6.32285 8.72339 6.11035 8.51089 6.11035 8.25464C6.11035 7.99839 6.32285 7.78589 6.5791 7.78589H9.7041C9.96035 7.78589 10.1729 7.99839 10.1729 8.25464C10.1729 8.51089 9.96035 8.72339 9.7041 8.72339Z",
    fill: "#292D32"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.36f7d613c00133e12dbbddd3d72082f9.svg";
export { ForwardRef as ReactComponent };